import React from "react";
import { useStarterPathway } from "../../hooks/start";
import css from "./Homepage.module.css";

const ListDatabaseHP = ({ dbList, statusSearch, setShowSpinnerFetch }) => {
  const renderBoxDb = (db) => {
    return (
      <BoxDBHP
        key={db.name}
        dbtitle={db.name}
        list={db.data}
        setShowSpinnerFetch={setShowSpinnerFetch}
      />
    );
  };

  if (statusSearch) {
    return (
      <div className={css.containerListHP}>
        <div className={css.listHP}>{dbList.map((db) => renderBoxDb(db))}</div>
      </div>
    );
  } else {
    return (
      <div className={css.listHP}>
        <div className={css.boxNoResultsHP}>
          <div style={{ placeSelf: "center" }}>No results.</div>
        </div>
      </div>
    );
  }
};

export default ListDatabaseHP;

const BoxDBHP = ({ dbtitle, list, setShowSpinnerFetch }) => {
  return (
    <div className={css.singleBoxDBHP}>
      <BoxTitleHP title={dbtitle} />
      <BoxListHP list={list} setShowSpinnerFetch={setShowSpinnerFetch} />
    </div>
  );
};

const BoxTitleHP = ({ title }) => {
  return (
    <div className={css.boxTitleHP} style={{ placeSelf: "center" }}>
      {title}
    </div>
  );
};

const BoxListHP = ({ list, setShowSpinnerFetch }) => {
  const { startPathway } = useStarterPathway();

  return (
    <div className={css.boxListRelativeHP} style={{ display: "block" }}>
      <div className={css.boxListAbsoluteHP}>
        <ul>
          {list.map((item) => {
            return (
              <li key={item.id}>
                <div
                  className={css.pathwayEntryHP}
                  onClick={() => {
                    setShowSpinnerFetch(true);
                    startPathway(item.species, item.database, item.nativeId);
                  }}
                  style={{
                    paddingTop: "10px",
                    paddingLeft: "5px",
                    hover: { color: "red" },
                  }}
                  title={`Nodes: ${item.num_nodes}\nEdges: ${item.num_edges}`}
                >
                  {item.title}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
